import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CalendarState } from './calendarFilterModel';
import { calendarMessages, calendarStateMessages } from './calendarMessages';
import { PostStateMark } from './PostStateMark';
import { ScheduledPostStatus } from '../types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

const LEGEND: Array<{ state: CalendarState; status: ScheduledPostStatus; className?: string }> = [
  { state: 'draft', status: 'draft', className: styles.stDraft },
  { state: 'scheduled', status: 'scheduled' },
  { state: 'needsYou', status: 'awaitingManualPost', className: styles.stManual },
  { state: 'published', status: 'posted', className: styles.stPosted },
  { state: 'failed', status: 'failed', className: styles.stFailed },
];

/** The state shapes and the time zone of the times (design a1). */
const CalendarLegendComponent: React.FC = () => {
  const intl = useIntl();
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <div className={styles.legend}>
      {LEGEND.map(({ state, status, className }) => (
        <span key={state}>
          <span className={clsx(styles.sw, className)}>
            <PostStateMark status={status} />
          </span>
          {intl.formatMessage(calendarStateMessages[state])}
        </span>
      ))}
      <span className={styles.legendZone}>{intl.formatMessage(calendarMessages.timezone, { zone })}</span>
    </div>
  );
};

export const CalendarLegend = TypedMemo(CalendarLegendComponent);
